// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sz01U","delete":"styles_delete__1e7BS","update":"styles_update__IrY1D","add":"styles_add__2H0wY"};